import { Box, Link, styled } from "@mui/material";
import { SelectArrowOrange } from "./Accordions.styled";

export const AccordionsSlideUpTitleBox = styled(Box)(({ theme }) => theme.unstable_sx({
    flexGrow: 1,
}));

export const SelectArrowOrangeRight = styled(SelectArrowOrange)(({ theme }) => ({
    transform: "rotate(270deg)"
}));

export const AccordionsMobileSlideUpRowWrapperLink = styled(Link)(({ theme }) => theme.unstable_sx({
    textDecoration: "none",
    color: "inherit",
    py: theme.spacing(3),
    gap: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    cursor: "pointer",
}));
